import {PureComponent} from "react";
import {createPortal} from "react-dom";
import {string, any} from "prop-types";
import document from "global/document";

let portalRoot;

class Portal extends PureComponent {
    constructor(props) {
        super(props);
        this.el = document.createElement("div");

        if(document.querySelector){
            portalRoot = document.querySelector(props.node);
        }
    }
    componentDidMount(){
        portalRoot && portalRoot.appendChild(this.el);
    }
    componentWillUnmount(){
        portalRoot  && portalRoot.removeChild(this.el);
    }
    render(){
        return createPortal(
            this.props.children,
            this.el
        );
    }
}

Portal.propTypes = {
    node: string.isRequired,
    children: any.isRequired
};

export default Portal;